import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Languages, Phone, Video, X, PhoneOff, MoreVertical } from 'lucide-react';
import { Avatar, Verified, TimeLeftPill, useNow } from './shared';
import { conversations, incomingCall } from '../mock';

function CallPopup({ onClose }) {
  return (
    <div className="absolute top-3 right-3 z-30 animate-pop-in">
      <div className="flex items-center gap-2.5 bg-[#0f1622] rounded-2xl px-3 py-2.5 shadow-2xl ring-1 ring-[#22304a] animate-call-ring">
        <Avatar src={incomingCall.avatar} size={38} />
        <div className="leading-tight mr-1">
          <p className="text-sm font-semibold text-white">{incomingCall.name}</p>
          <p className="text-[11px] text-[#8b95a5]">{incomingCall.expiresLabel}</p>
        </div>
        <button onClick={onClose} className="w-9 h-9 rounded-full bg-[#22c55e] flex items-center justify-center active:scale-90 transition-transform">
          <Phone size={16} className="text-white fill-white" />
        </button>
        <button onClick={onClose} className="w-9 h-9 rounded-full bg-[#f43f5e] flex items-center justify-center active:scale-90 transition-transform">
          <PhoneOff size={16} className="text-white" />
        </button>
      </div>
    </div>
  );
}

export default function Chats() {
  const navigate = useNavigate();
  const now = useNow();
  const [showCall, setShowCall] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowCall(true), 1800);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="relative">
      {showCall && <CallPopup onClose={() => setShowCall(false)} />}

      <div className="flex items-center justify-between px-4 py-3 text-[13px] text-[#8b95a5] bg-[#0a0f18]">
        <span className="font-medium">Inbox <span className="text-[#5c6675]">(Expires in 24h)</span></span>
        <MoreVertical size={18} />
      </div>

      <ul>
        {conversations.map((c) => (
          <li key={c.id}>
            <button
              onClick={() => navigate(`/chats/${c.id}`)}
              className="w-full flex items-center gap-3 px-4 py-3.5 hover:bg-[#0e1522] active:bg-[#0e1522] transition-colors text-left"
            >
              <Avatar src={c.avatar} size={52} online={c.online} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-1.5">
                  <span className="text-[15px] font-semibold text-white truncate">{c.name}</span>
                  {c.verified && <Verified size={14} />}
                  {c.online && <span className="w-4 h-2 rounded-full bg-[#22c55e]" />}
                </div>
                <div className="flex items-center gap-1.5 mt-0.5">
                  {c.typing ? (
                    <span className="text-[13px] text-[#2f8bff] font-medium">Typing...</span>
                  ) : (
                    <span className="text-[13px] text-[#8b95a5] truncate">{c.preview}</span>
                  )}
                  {c.translated && (
                    <span className="flex items-center gap-0.5 text-[11px] text-[#8b95a5]">
                      <Languages size={11} /> Translated
                    </span>
                  )}
                </div>
              </div>
              <div className="flex flex-col items-end gap-1.5">
                <TimeLeftPill target={c.expiresAt} now={now} />
                {c.locked && <Lock size={13} className="text-[#5c6675]" />}
              </div>
            </button>
            <div className="h-px bg-[#141c28] ml-[76px]" />
          </li>
        ))}
      </ul>
      <p className="text-center text-[12px] text-[#5c6675] py-6">Messages disappear after 24 hours.</p>
    </div>
  );
}
